import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ElementRef } from '@angular/core';
import { SearchComponent } from '@enginuity/core/molecules/search/search.component';
import { SecondaryBtnsComponent } from '@enginuity/core/molecules/secondary-btns/secondary-btns.component';
import {
  FILTER_ACTIVE_INFO,
  FILTER_ATTRIBUTES,
  FILTER_DROPDOWN,
  FILTER_GROUP_DATA,
  FILTER_TAB_CONTENT,
  STRING_COMPARISON_FILTERS,
} from '@services/ui-services/constants/table-filter.constant';
import { LinkBtnComponent } from '@enginuity/core/molecules/tertiary/link-btn.component';
import { FilterTagComponent } from '@enginuity/core/organisms/filter-tag/filter-tag.component';
import { FilterConditionComponent } from '@enginuity/core/organisms/filter-condition/filter-condition.component';

@Component({
  selector: 'app-table-filter',
  templateUrl: './table-filter.component.html',
  styleUrls: ['./table-filter.component.scss'],
  imports: [
    CommonModule,
    SearchComponent,
    SecondaryBtnsComponent,
    LinkBtnComponent,
    FilterTagComponent,
    FilterConditionComponent,
  ],
})
export class TableFilterComponent {
  @Output() custom_click = new EventEmitter<any>();
  @Input() filters: any[] = [];

  @Input() filter_group_data: any = FILTER_GROUP_DATA;
  @Input() showSearch: boolean = false;

  attribute = FILTER_ATTRIBUTES;
  dropdown = FILTER_DROPDOWN;
  tabContent = FILTER_TAB_CONTENT;
  active_info = FILTER_ACTIVE_INFO;
  stringFilters: any = STRING_COMPARISON_FILTERS;

  searchData = '';
  constructor(private elRef: ElementRef) {}

  onActionClick(event: any, filter: any = {}) {
    switch (event.action) {
      case 'filter_add_tag':
        this.filters.push(event.value);
        break;
      case 'filter_search':
        this.searchData = event.value;
        this.onSearch();
        break;
      case 'filter_clear_all':
        this.filters.map(x => (x.filter.isShow = true));
        this.filters = [];
        this.onSearch();
        break;
      case 'filter_clear_by_filter_by':
        this.filters = this.filters.filter((x: any) => x.filter_in !== event.value);
        this.onSearch();
        break;
      case 'filter_remove':
        this.filters.splice(this.filters.indexOf(event.value), 1);
        this.onSearch();
        break;
      case 'filter_tag_search':
        filter.filterData = event.value;
        this.onSearch();
        break;
      default:
        break;
    }
    setTimeout(() => {
      const items = this.elRef.nativeElement.querySelectorAll('.tag-dropdown .dropdown-menu.show');
      items.forEach((element: any) => {
        element.classList.remove('show');
      });
    }, 300);
  }

  onSearch() {
    const filterData = this.filters.map(x => x.filterData);
    const dataArray: any = [];
    filterData.forEach(element => {
      if (element)
        element?.forEach((x: any) => {
          if (x) dataArray.push(x);
        });
    });

    this.custom_click.emit({
      action: 'filter_search',
      value: {
        searchData: this.searchData,
        filters: dataArray,
      },
    });
  }
}
